module.exports = __webpack_public_path__ + "img/btn-start.0ea44e32.png";